import React, { useState} from 'react';
import './Createprof.css';


const Createprof = () => {
  // Initialize user data with default values
  const [userData, setUserData] = useState({
    firstName: 'Tushar',
    email: 'tsgupta21@example.com',
    profilePicture: null, 
    collegename:"Select College Name",
    semester:"Select Semester",
    subject:"Select Subject",
    instagramLink: '', // Instagram link
    twitterLink: '',   // Twitter link
    linkedinLink: '',  // LinkedIn link
    githubLink: '',    // GitHub link
  });

  const [isEditing, setIsEditing] = useState(false);
  

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
  };

   const handleCollegeChange = (e) => {
    const collegename = e.target.value;
    setUserData({ ...userData, collegename });
  };

  const handleSemesterChange = (e) => {
    const semester = e.target.value;
    setUserData({ ...userData, semester });
  };

  const handleSubjectChange = (e) => {
    const subject = e.target.value;
    setUserData({ ...userData, subject });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleProfilePictureChange = (e) => {
    const selectedFile = e.target.files[0];
    setUserData({ ...userData, profilePicture: selectedFile });
  };

  return (
    <section className='sec'>
    <div className="profile">
      <h1>My Profile</h1>
      <div className='udts'>
      <div className="profile-info">
        <div>
          <label>Name:</label>
          {isEditing ? (
            <input
              type="text"
              name="firstName"
              value={userData.firstName}
              onChange={handleInputChange}
            />
          ) : (
            <span>{userData.firstName}</span>
          )}
        </div>
        <div>
          <label>Email:</label>
          {isEditing ? (
            <input
              type="email"
              name="email"
              value={userData.email}
              onChange={handleInputChange}
            />
          ) : (
            <span>{userData.email}</span>
          )}
        </div>
        <div>
          <label>Contact Number</label>
          {isEditing ? (
            <input
              type="text"
              name="conactnumber"
              value={userData.contactnumber}
              onChange={handleInputChange}
            />
          ) : (
            <span>{ '+91 '+ userData.contactnumber}</span>
          )}
        </div>
        <div>
              <label>College:</label>
              {isEditing ? (
                <select
                  name="college"
                  value={userData.collegename}
                  onChange={handleCollegeChange}
                >
                  <option value="">Select College</option>
            <option value="BIT RAIPUR">BIT RAIPUR</option>
            <option value="NIT RAIPUR">NIT RAIPUR</option>
            <option value="SSTC RAIPUR">SSTC RAIPUR</option>
            <option value="SSTC Bhilai">SSTC Bhilai</option>
            <option value="GEC RAIPUR">GEC RAIPUR</option>
            <option value="AMITY RAIPUR">AMITY RAIPUR</option>
            <option value="IIIT NAYA RAIPUR">IIIT NAYA RAIPUR</option>
            <option value="BIT DURG">BIT DURG</option>
                  
                  {/* Add more semester options as needed */}
                </select>
              ) : (
                <span>{userData.collegename}</span>
              )}
            </div>
         <div>
              <label>Semester:</label>
              {isEditing ? (
                <select
                  name="semester"
                  value={userData.semester}
                  onChange={handleSemesterChange}
                >
                  <option value="1st Semester">1st Semester</option>
                  <option value="2nd Semester">2nd Semester</option>
                  <option value="3rd Semester">3rd Semester</option>
                  <option value="4th Semester">4th Semester</option>
                  <option value="5th Semester">5th Semester</option>
                  <option value="6th Semester">6th Semester</option>
                  <option value="7th Semester">7th Semester</option>
                  <option value="8th Semester">8th Semester</option>
                  {/* Add more semester options as needed */}
                </select>
              ) : (
                <span>{userData.semester}</span>
              )}
            </div>
            <div>
              <label>Subject:</label>
              {isEditing ? (
                <select
                  name="subject"
                  value={userData.subject}
                  onChange={handleSubjectChange}
                >
                  <option value="Math">Math</option>
                  <option value="Science">Science</option>
                  {/* Add more subject options as needed */}
                </select>
              ) : (
                <span>{userData.subject}</span>
              )}
            </div>
            <div>
              <label>Instagram:</label>
              {isEditing ? (
                <input
                  type="text"
                  name="instagramLink"
                  value={userData.instagramLink}
                  onChange={handleInputChange}
                />
              ) : (
                <a href={userData.instagramLink} target="_blank" rel="noopener noreferrer">{userData.instagramLink}</a>
              )}
            </div>
            <div>
              <label>Twitter:</label>
              {isEditing ? (
                <input
                  type="text"
                  name="twitterLink"
                  value={userData.twitterLink}
                  onChange={handleInputChange}
                />
              ) : (
                <a href={userData.twitterLink} target="_blank" rel="noopener noreferrer">{userData.twitterLink}</a>
              )}
            </div>
            <div>
              <label>LinkedIn:</label>
              {isEditing ? (
                <input
                  type="text"
                  name="linkedinLink"
                  value={userData.linkedinLink}
                  onChange={handleInputChange}
                />
              ) : (
                <a href={userData.linkedinLink} target="_blank" rel="noopener noreferrer">{userData.linkedinLink}</a>
              )}
            </div>
            <div>
              <label>GitHub:</label>
              {isEditing ? (
                <input
                  type="text"
                  name="githubLink"
                  value={userData.githubLink}
                  onChange={handleInputChange}
                />
              ) : (
                <a href={userData.githubLink} target="_blank" rel="noopener noreferrer">{userData.githubLink}</a>
              )}
            </div>
        </div>
       <div className="profile-picture">
        {isEditing ? (
          <input
            type="file"
            name="profilePicture"
            id="profilePicture"
            accept="image/*"
            onChange={handleProfilePictureChange}
          />
        ) : (
          <img
            src={userData.profilePicture ? URL.createObjectURL(userData.profilePicture) : 'default-profile-image.jpg'}
            alt=" "
            className="profile-image"
          />
        )}
        </div>
</div>

      

      {isEditing ? (
        <button className='bachan' onClick={handleSaveClick}>Save</button>
      ) : (
        <button className='bachan' onClick={handleEditClick}>Edit</button>
      )}
    </div>
    </section>
  );
};

export default Createprof;
